import { LeasingOption } from '~/models/classified/leasing/types'

export function formatLeasingOption(leasingOption: any): LeasingOption {
  return {
    mileage: {
      value: leasingOption.mileage.value,
      suffix: leasingOption.mileage.suffix
    },
    duration: {
      value: leasingOption.duration.value,
      suffix: leasingOption.duration.suffix
    },
    lease: {
      valueWithVat: leasingOption.lease.value_with_vat,
      valueWithoutVat: leasingOption.lease.value_without_vat,
      suffix: leasingOption.lease.suffix
    },
    downpayment: {
      valueWithVat: leasingOption.downpayment.value_with_vat,
      valueWithoutVat: leasingOption.downpayment.value_without_vat,
      suffix: leasingOption.downpayment.suffix
    },
    purchasePrice: leasingOption.purchase_price && {
      valueWithVat: leasingOption.purchase_price.value_with_vat,
      valueWithoutVat: leasingOption.purchase_price.value_without_vat,
      suffix: leasingOption.purchase_price.suffix
    }
  }
}
